import { http, largeFileConfig } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { Endpoints } from '@/core/models/endpoints.interface';
import { LocationQuery } from 'vue-router';
import { Employee } from './employee.interface';

export interface EMPLOYEE_ENDPOINTS extends Pick<Endpoints, 'GET' | 'GET_ALL'> {
   GET_IDENTITY_CARD_URLS: (employeeId: number) => string;
   PUT_PAYMENT_SYSTEM_DATA: (employeeId: number) => string;
}

export const EMPLOYEE_ENDPOINTS: EMPLOYEE_ENDPOINTS = {
   GET: (employeeId: number) => `/employees/${employeeId}`,
   GET_ALL: () => `/nxt-employees`,
   GET_IDENTITY_CARD_URLS: (employeeId: number) => `/employees/${employeeId}/identity-card-urls`,
   PUT_PAYMENT_SYSTEM_DATA: (employeeId: number) => `/employees/${employeeId}/payment-system-data`,
};

export class EmployeeService {
   async getEmployees(query: LocationQuery) {
      const response = await http.get<PaginatedResponse<Employee>>(`/employees`, { params: { ...query, append: 'scopes' } });
      return response.data;
   }
   async getEmployee(employeeId: number, query: LocationQuery) {
      const response = await http.get<ApiResource<Employee>>(`/employees/${employeeId}`, { params: { ...query } });
      return response.data?.data;
   }
   async putEmployee(employeeId: number, employee: Employee) {
      const response = await http.put<ApiResource<Employee>>(`/employees/${employeeId}`, employee, { params: { append: 'scopes' } });
      return response.data?.data;
   }
   async postEmployee(employee: Employee) {
      const response = await http.post<ApiResource<Employee>>('/employees', employee, { params: { append: 'scopes' } });
      return response.data?.data;
   }
   async deleteEmployee(employeeId: number) {
      return http.delete(`/employees/${employeeId}`);
   }

   async searchEmployees(params: LocationQuery) {
      const response = await http.get<PaginatedResponse<Employee>>(`/employees`, { params });
      return response.data.data || [];
   }

   async getEmployeeById(employeeId: number) {
      return await http
         .get(`/employees/${employeeId}`, {
            params: {
               append: 'scopes',
            },
         })
         .then((response) => response.data.data);
   }

   async getEmployeesByCompany(companyId: number) {
      return await http
         .get(`/companies/${companyId}/employees`, {
            params: {
               per_page: 500,
               page: 1,
            },
         })
         .then((response) => response.data);
   }

   async importEmployeesTranslations(file: File) {
      const formData = new FormData();
      formData.append('file', file);
      const response = await http.post(`/import-employees-translations`, formData);
      return response.data;
   }

   async importEmployees(file: File, employeeMappings: { [key: string]: any }) {
      const formData = new FormData();
      formData.append('file', file);
      Object.entries(employeeMappings).forEach(([key, value]: any) => {
         formData.append(key, value);
      });
      const response = await http.post(`/import-employees`, formData, largeFileConfig);
      return response.data;
   }
}
